<div class="orders pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border py-2 mb-4">
    <h1>Order Tracking</h1>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </header>

  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="orderTrackingGridListing"
    styleClass="p-datatable-customers ordersListing search-more"
    [rowHover]="true"
    [rows]="250"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
    [paginator]="true"
    [filterDelay]="0">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem" class="number">Freight billing number</th>
        <th class="status">Freight invoice number</th>
        <th class="name">Invoice date</th>
        <th class="jname">Carrier</th>
        <th class="buyer">Tracking Number</th>
        <th class="inhanddate">Hundred weight</th>
        <th class="date-time">Freight retail price</th>
        <th class="subtotal">Freight cost price</th>
        <th class="subtotal">Freight sell price</th>
        <th class="subtotal">Freight discount</th>
        <th class="subtotal">Customers and duty</th>
        <th class="subtotal">JNI responsible</th>
        <th class="subtotal">JNI responsible name</th>
        <th class="subtotal">Billed to type</th>
        <th class="subtotal">Billed to reference</th>
        <th class="subtotal">JNI reference</th>
        <th class="subtotal">JNI reference 2</th>
        <th class="subtotal">JNI reference 3</th>
        <th class="subtotal">JNI reference 4</th>
        <th class="subtotal">JNI reference 5</th>
        <th class="subtotal">Exceptions</th>
        <th class="subtotal">Original order</th>
        <th class="subtotal">Freight match status</th>
        <th class="subtotal">Approved</th>
        <th class="subtotal">Approved by</th>
        <th class="subtotal">Approved date</th>
        <th class="subtotal">AP invoice journal</th>
        <th class="subtotal">Matched journal</th>
        <th class="subtotal">Voucher</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderTrackingGridListing
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="orderTrackingGridListing"
        [pSelectableRowIndex]="rowIndex">
        <td class="number">
          {{ orderTrackingGridListing?.FreightBillingNum }}
        </td>
        <td class="status">
          {{ orderTrackingGridListing?.FreightInvoiceNum }}
        </td>
        <td class="name">
          <span
            *ngIf="orderTrackingGridListing?.InvoiceDate | hidedynamicsdate">
            {{ orderTrackingGridListing?.InvoiceDate | date: "MM-dd-yyyy" }}
          </span>
        </td>
        <td class="jname">
          {{ orderTrackingGridListing?.Carrier }}
        </td>
        <td class="number">
          {{ orderTrackingGridListing?.TrackingNumber }}
        </td>
        <td class="buyer">
          {{ orderTrackingGridListing?.HundredWeight }}
        </td>
        <td class="inhandate">
          {{
            orderTrackingGridListing?.FreightRetailPrice
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="date-time">
          {{
            orderTrackingGridListing?.FreightCostPrice
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="date-time">
          {{
            orderTrackingGridListing?.FreightSellPrice
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="subtotal">
          {{
            orderTrackingGridListing?.CustomsDutyPrice
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="number">
          {{ orderTrackingGridListing?.JNIResponsible }}
        </td>
        <td class="status">
          {{ orderTrackingGridListing?.JNIResponsible }}
        </td>
        <td class="name">
          {{ orderTrackingGridListing?.BilledToType }}
        </td>
        <td class="jname">
          {{ orderTrackingGridListing?.BilledToReference }}
        </td>
        <td class="buyer">
          {{ orderTrackingGridListing?.JNIReference }}
        </td>
        <td class="inhandate">
          {{ orderTrackingGridListing?.JNIReference2 }}
        </td>
        <td class="date-time">
          {{ orderTrackingGridListing?.JNIReference3 }}
        </td>
        <td class="subtotal">
          {{ orderTrackingGridListing?.JNIReference4 }}
        </td>
        <td class="number">
          {{ orderTrackingGridListing?.JNIReference5 }}
        </td>
        <td class="status">
          {{ orderTrackingGridListing?.Exceptions }}
        </td>
        <td class="name">
          {{ orderTrackingGridListing?.OriginalOrder }}
        </td>
        <td class="jname">
          {{ orderTrackingGridListing?.MatchStatus }}
        </td>
        <td class="buyer">
          {{ orderTrackingGridListing?.Approved }}
        </td>
        <td class="inhandate">
          {{ orderTrackingGridListing?.ApprovedBy }}
        </td>
        <td class="date-time">
          <span
            *ngIf="
              orderTrackingGridListing?.ApprovedDateTime | hidedynamicsdate
            ">
            {{
              orderTrackingGridListing?.ApprovedDateTime | date: "MM-dd-yyyy"
            }}
          </span>
        </td>
        <td class="subtotal">
          {{ orderTrackingGridListing?.ImportJournalId }}
        </td>
        <td class="buyer">
          {{ orderTrackingGridListing?.MatchedJournalId }}
        </td>
        <td class="inhandate">
          {{ orderTrackingGridListing?.Voucher }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No order tracking found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
